import { StoreColourSetting } from 'Shared/backend/settingsPage/ColourSetting';
import { StyleFieldsRow } from 'Shared/backend/styles/StyleFieldsRow';


export function MenuButtonColours()
{
	return (
		<StyleFieldsRow>
			<MenuButtonColoursFields />
		</StyleFieldsRow>
	);
}


/* The two menu button-row colours on their own, for a caller that names the location itself - see
   ruleProperties(). Each button of a sticky button row is marked Plain, Food or Drinks in the menu
   designer; these colour the Food and Drinks ones, and a Plain button shows whatever is behind it. */
export function MenuButtonColoursFields()
{
	return (<>
		<StoreColourSetting field='food' label='Food' notes='' />
		<StoreColourSetting field='drinks' label='Drinks' notes='' />
	</>);
}
